import { ConnectionRequestType } from '@mm/state/model/ConnectionModel';

export const REQUEST_TYPE_OPTIONS = {
  [ConnectionRequestType.GET]: {
    id: ConnectionRequestType.GET,
    key: ConnectionRequestType.GET,
    name: 'GET',
  },
  [ConnectionRequestType.POST]: {
    id: ConnectionRequestType.POST,
    key: ConnectionRequestType.POST,
    name: 'POST',
  },
};
